<template>
  <form @submit.prevent="saveQuestion">
    <mu-card id="create-question">
      <mu-card-header
        :title="$t('message.questionCreateTitle')"
        titleClass="blueTitle largeTitle titleRemovePadding"
      ></mu-card-header>
      <mu-card-text>
        <div class="communityText" v-text="$t('message.questionCreateSubTitle')"></div>
        <div class="field">
          <mu-text-field
            v-validate
            :data-vv-rules="'required'"
            data-vv-name="question"
            data-vv-value-path="inputValue"
            data-vv-validate-on="none"
            :data-vv-as="$t('message.questionCreateLabelTitle')"
            :errorText="errors.first('question')"
            v-model="model.question"
            id="focusable"
            :label="$t('message.questionCreateLabelTitle')"
            :hintText="$t('message.questionCreateTitlePlaceholder')"
            :helpText="$t('message.questionCreateTitleHelpText')"
            fullWidth
          />
        </div>
        <div class="field">
          <mu-text-field
            v-validate
            :data-vv-rules="'required'"
            data-vv-name="content"
            data-vv-value-path="inputValue"
            data-vv-validate-on="none"
            :data-vv-as="$t('message.questionCreateLabelText')"
            :errorText="errors.first('content')"
            v-model="model.content"
            :label="$t('message.questionCreateLabelText')"
            multiLine
            :rows="3"
            :rowsMax="6"
            :hintText="$t('message.questionCreateTextPlaceholder')"
            :fullWidth="true"
            class="textarea"
          ></mu-text-field>
        </div>

        <!--
        <div class="field">
          <mu-select-field label="Category" v-model="model.category" full-width :hint-text="$t('message.selectText')">
            <mu-menu-item v-for="item in categories" :title="item.name" :value="item.id"></mu-menu-item>
          </mu-select-field>
        </div>
        -->
        <!--<mu-flat-button
          :label="$t('message.cancelText')"
          @click.native="goBack"
        />-->
        <mu-raised-button
          class="submitBtn"
          :disabled="isSaving"
          :label="isSaving ? $t('message.savingText') : $t('message.submitText')"
          @click.native="saveQuestion"
          fullWidth
        />
      </mu-card-text>
    </mu-card>
  </form>
</template>
<script>
  import DiscussionApi from '../../../api/Discussion';
  import MuTextField from "../../../../node_modules/muse-ui/src/textField/textField";
  import MuFlatButton from "../../../../node_modules/muse-ui/src/flatButton/flatButton";
  import MuSelectField from "muse-ui/src/selectField/selectField";

  export default {
    components: {
      MuSelectField,
      MuFlatButton,
      MuTextField
    },
    name: "create-question",
    data () {
      return {
        isSaving: false,
        user: {},
        model: {},
        categories: []
      }
    },
    mounted() {
      let self = this;
      self.user = self.$store.state.user;
      $('#focusable input').focus();

      DiscussionApi.getCategories()
        .then(function (response) {
          self.categories = response.data;
        })

    },
    methods: {
      goBack() {
        window.history.back();
      },
      saveQuestion() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            self.isSaving = true;
            if (valid) {
              DiscussionApi.createDiscussionThread(self.model)
                .then(function (response) {

                  self.$gtag.event('AskedQuestion',{
                    'event_category': 'Questions',
                    'event_label': 'Asked a question',
                    'value': 1
                  });

                  self.isSaving = false;

                  self.$router.push(
                    {
                      path: '/questions/thread/' + response.data.last_id,
                      query: {
                        page: 1,
                        per_page: 10
                      }
                    }
                  )
                }).catch(error => {
                  if(error.response.data) {
                    self.isSaving = false;
                    self.$toastr.error(error.response.data.message);
                  }
              });
            } else {
              self.isSaving = false;
            }
          })
      }
    }
  }
</script>
<style lang="less">
  @import "../../../styles/theme.less";




  #questions-index .horizontalScroll {
    overflow-x: auto !important;
  }



  #create-question {
    .mu-card-header {
      padding-bottom: 0;
      .mu-card-header-title {
        padding-right: 0;
        .mu-card-title {
          font-weight: 500;
        }
      }
    }
    .mu-text-field-focus-line {
      background-color: @primaryColor!important;
    }
    .mu-card-text {
      padding-top: 8px;
    }
    .communityText {
      margin: 0 0 16px;
      font-size: 16px;
      color: #000;
    }
    .mu-text-field-hint {
      color: rgba(0, 0, 0, 0.42);
    }
    .field {
      margin: 0 0 10px;
    }
    .submitBtn {
      height: 50px;
      line-height: 50px;
      color: #FFF;
      font-size: 15px;
      background-color: @primaryColor;
      box-shadow: none;
      text-transform: none;
    }
  }
</style>



// WEBPACK FOOTER //
// CreateQuestion.vue?3cc8ad70